<template><div><h1>autoprefix 推荐配置</h1>
<p><code>vue</code>官方模板的设置是<code>last 2 versions</code>，可能会导致你在某些<code>Android</code>机子上出现问题。</p>
<p>如果你使用 <code>last 7 versions</code> 会生成不必要的<code>-ms</code>前缀代码.</p>
<p>因此建议同<code>WeUI</code>一样，使用配置 <code>['iOS &gt;= 7', 'Android &gt;= 4.1']</code></p>
<h2>直接在 vux-loader 里配置</h2>
<p>如果你没有在 postcss 里配置，你可以直接配置 vux-loader 的 <code>duplicate-style</code> 插件：</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'duplicate-style'</span>,
  <span class="hljs-attr">options</span>: {
    <span class="hljs-attr">cssProcessorOptions</span> : {
      <span class="hljs-attr">safe</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">zindex</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">autoprefixer</span>: {
        <span class="hljs-attr">add</span>: <span class="hljs-literal">true</span>,
        <span class="hljs-string">"browsers"</span>: [
          <span class="hljs-string">"iOS &gt;= 7"</span>,
          <span class="hljs-string">"Android &gt;= 4.1"</span>
        ]
      }
    }
  }
}
</code></pre>
</div></template><script>
export default {
  head: {"title":"vue-loader autoprefix 推荐配置 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-loader-autoprefix-287.vue?6da831f2